<div class="product-card" [ngClass]="{
    'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
    'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
    'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    'product-card--layout--list':                        layout === 'list',
    'product-card--layout--horizontal':                  layout === 'horizontal'
}">
    <button [attr.title]="'quick-view' | t:'Quick View'" class="product-card__quickview" type="button" appClick (click)="showQuickview()" [ngClass]="{'product-card__quickview--preload': showingQuickview}">
        <app-icon name="quickview-16" size="16"></app-icon>
        <span class="fake-svg-icon"></span>
    </button>

    <div *ngIf="product.Badges?.length" class="product-card__badges-list" style="display: flex; flex-direction: row; flex-wrap: wrap;"> 
        <!-- A discount and a sale are one offer, so one tag: "-30% SALE", not two side by side. -->
        <div *ngIf="discount > 0" class="product-card__badge product-card__badge--sale" style="font-size: 14px;" >-{{discount}}%<span *ngIf="product.Badges.includes('sale')" class="product-card__badge-word">{{ 'badge-sale' | t:'SALE' }}</span></div>
        <div *ngIf="!(discount > 0) && product.Badges.includes('sale')" class="product-card__badge product-card__badge--sale">{{ 'badge-sale' | t:'SALE' }}</div>
        <div *ngIf="product.Badges.includes('hot')" class="product-card__badge product-card__badge--hot">{{ 'badge-hot' | t:'Hot' }}</div>
        <div *ngIf="product.Badges.includes('toprated')" class="product-card__badge product-card__badge--new">{{ 'badge-rated' | t:'Rated' }}</div>
        <div *ngIf="notSoldIn" class="product-card__badge product-card__badge--not-sold"
             [title]="'product-card-not-sold-in-tip' | t:'Not sold in {country}: shoppers there never see this product. You see it because you are signed in as the owner.':{ country: notSoldIn }">{{ 'product-card-not-sold-in' | t:'Not sold in {country}':{ country: notSoldIn } }}</div>
    </div>

    <div *ngIf="!product.Badges?.length" class="product-card__badges-list" style="display: flex; flex-direction: row; flex-wrap: wrap;">
        <div *ngIf="discount > 0" class="product-card__badge product-card__badge--sale" style="font-size: 14px;">-{{discount}}%</div>
        <!-- <div *ngIf="product.Discount >= sellAt" class="product-card__badge product-card__badge--new">Sale</div> -->
        <div *ngIf="notSoldIn" class="product-card__badge product-card__badge--not-sold"
             [title]="'product-card-not-sold-in-tip' | t:'Not sold in {country}: shoppers there never see this product. You see it because you are signed in as the owner.':{ country: notSoldIn }">{{ 'product-card-not-sold-in' | t:'Not sold in {country}':{ country: notSoldIn } }}</div>
    </div>

    <div class="product-card__image product-image">
        <!-- A card showing one of the product's other colours hands it to the page in the router's
             state, never in the URL, so the page opens on that colour at the price shown here. -->
        <a appClick [routerLink]="root.product(product)" [state]="product.ShowcaseVariant ? {showcaseVariant: product.ShowcaseVariant} : undefined" (click)="selected()" *ngIf="product.Image" class="product-image__body">
          
            <!-- Image2 is the 480px webp thumbnail. A product whose thumbnail could not be made when it was
                 saved has only Image, the picture itself - the card shows that, never an empty frame. -->
            <picture>
                <source *ngIf="product.Image2" type="image/webp" [srcset]="product.Image2">
                <img loading="lazy" class="product-image__img" [src]="product.Image2 || product.Image" [alt]="product.Name">
            </picture>  
        </a>
    </div>
    <div class="product-card__info">
        <div class="product-card__name" [ngClass]="{'slider-class': isSlider}">
            <a appClick [routerLink]="root.product(product)" [state]="product.ShowcaseVariant ? {showcaseVariant: product.ShowcaseVariant} : undefined" (click)="selected()">{{ product | productName }}</a>
        </div>
        <div class="product-card__rating" style="margin-left: -3px; flex-wrap: wrap;" [ngStyle]="layout === 'horizontal' ? {'margin-bottom': '14px'} : {}">
            <app-rating [value]="product.Rating"></app-rating>
            <div class="product-card__rating-legend">
               ({{product.Rating | number:'1.1-1'}})
            </div>
            <div class="text-secondary" style="margin-left: auto; font-size: 12px; font-weight: 600;" *ngIf="product.ShowStock > 0 && product.ShowStock < 6">
                {{ 'stock-left' | t:'{count} Left':{ count: product.ShowStock } }}
            </div>
        </div>
        <ul *ngIf="featuredAttributes.length" class="product-card__features-list">
            <li *ngFor="let attribute of featuredAttributes">
                {{ attribute.name }}:
                <ng-container *ngFor="let value of attribute.values; let last = last">
                    {{ value.name }}<ng-container *ngIf="!last">, </ng-container>
                </ng-container>
            </li>
        </ul>
    </div>
    <div class="product-card__actions">
        <div class="product-card__availability">
            {{ 'availability-label' | t:'Availability:' }} 
           <span *ngIf="product.AvailableQuantity > 0" class="text-success">{{ 'in-stock-title' | t:'In Stock' }}</span>
           <span *ngIf="product.AvailableQuantity < 1" class="text-danger">{{ 'out-of-stock-label' | t:'Out Of Stock' }}</span>
        </div>
        <div class="product-card__prices" style="flex-wrap: wrap;">
            <ng-container *ngIf="regularPrice > 0 && price > 0">
                <span class="prod-price" [class.prod-price-max]="discount >= sellAt">
                    {{currency.options.display}}{{ getFormattedPrice().whole }}<sup *ngIf="getFormattedPrice().fraction">.{{ getFormattedPrice().fraction }}</sup>
                </span>{{ ' ' }}
                <span *ngIf="regularPrice > price" class="product-card__old-price" style="margin-left: 8px; font-size: 15px;">{{ regularPrice|currencyFormat }}</span>
            </ng-container> 

            <ng-container *ngIf="price > 0 &&  regularPrice <= 0">
                <span class="prod-price">{{ price|currencyFormat }}</span>
            </ng-container>

            <ng-container *ngIf="price < 1">
                {{ 'upcoming' | t:'Upcoming' }}
            </ng-container>

            <p class="brnd-p" *ngIf="!hideBrand">
                <app-icon *ngIf="product.IsFreeShipping" name="fi-free-delivery-48" size="26" style="fill: var(--ph-primary);" [tooltip]="'free-shipping-title' | t:'Free Shipping'"></app-icon>
                <!-- <span  *ngIf="product.IsFreeShipping" class="text-secondary">Free Shipping</span> -->
                <a *ngIf="!product.IsFreeShipping" [routerLink]="root.brandWithCat(product.BrandSlug, product.CategorySlug)">{{product.BrandName}}</a>
            </p>
        </div>
        <div class="product-card__buttons">  
            <button class="btn btn-primary product-card__addtocart" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}">
                {{ 'add-to-cart-title' | t:'Add to Cart' }}
            </button> 
 
            <button class="btn btn-secondary product-card__addtocart product-card__addtocart--list" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}">
                {{ 'add-to-cart-title' | t:'Add to Cart' }}
            </button>
            <button [attr.title]="'add-to-wishlist' | t:'Add To Wishlist'" class="btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist" type="button" appClick (click)="addToWishlist()" [ngClass]="{'btn-loading': addingToWishlist}">
                <app-icon name="wishlist-16" size="16"></app-icon>
                <span class="fake-svg-icon fake-svg-icon--wishlist-16"></span>
            </button>
            <button [attr.title]="'add-to-compare' | t:'Add To Compare'" class="btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__compare" type="button" appClick (click)="shareLink()">
                <app-icon name="share_fill1" size="16"></app-icon>
                <span class="fake-svg-icon fake-svg-icon--compare-16"></span>
            </button>
        </div>
    </div>
</div>
